export default {"src":"/_next/static/media/KG2.9b9cf754.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};